<template>
    <span v-on:click.stop="initEditMode" :class="containerClassObject">
        <icon class="w-4 h-4 inline-block" name="pencil" v-if="this.allowed && this.isViewMode && !this.updated"/>
        <icon class="w-4 h-4 inline-block" name="clock" v-if="this.allowed && this.isViewMode && this.updated"/>
        <span v-if="this.isViewMode">
            <slot/>
        </span>
        <input :required="required" :class="inputClassObject" ref="editInput" v-if="this.isEditMode && this.type === 'text'" type="text" v-model="updatedValue" @keydown.esc="toggleMode" @keydown.enter="update">
        <input :required="required" :class="inputClassObject" ref="editInput" v-else-if="this.isEditMode && this.type === 'number'" type="number" :min="min" :step="step" :max="max" v-model="updatedValue" @keydown.esc="toggleMode" @keydown.enter="update">
    </span>
</template>

<script>
import Icon from '@/Shared/Icon';
export default {
    name: "ClickToEdit",
    components: {
        Icon
    },
    props: {
        allowed: Boolean,
        name: String,
        type: {
            type: String,
            default: 'text'
        },
        min: {
            type: Number,
            default: null
        },
        step: {
            type: Number,
            default: 1
        },
        max: {
            type: Number,
            default: null
        },
        forceClose: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mode: 'VIEW',
            updatedValue: '',
            hasError: false,
            updated: false
        }
    },
    created() {
      this.updatedValue = '';
    },
    methods: {
        initEditMode(e) {
            if (this.isViewMode && this.allowed) {
                this.toggleMode();
            }
        },
        toggleMode() {
          if (this.isViewMode && this.allowed) {
              this.updatedValue = '';
              this.mode = 'EDIT';
              this.$nextTick(() => {
                this.$refs.editInput.focus();
              });
              this.$emit('state', true);
          } else {
              this.mode = 'VIEW';
              this.$emit('state', false);
          }
        },
        update() {
            this.hasError = !this.$refs.editInput.checkValidity();
            if (!this.hasError) {
                if (this.hasChanges) {
                    this.$emit('update', {
                        'name': this.name,
                        'value': this.updatedValue
                    });
                    this.updated = true;
                }
                this.toggleMode();
            }
        }
    },
    computed: {
        hasChanges() {
            return this.updatedValue !== this.originValue
                && this.updatedValue !== ''
                && !(this.type === 'number' && isNaN(this.updatedValue));
        },
        isViewMode() {
            return this.mode === 'VIEW';
        },
        isEditMode() {
            return this.mode === 'EDIT';
        },
        originValue() {
            return this.$attrs.origin;
        },
        inputClassObject() {
            return {
                'border border-red-500 text-red-500 border-l-4': this.hasError || !this.valid
            }
        },
        containerClassObject() {
            return {
                'bg-red-500 p-1': !this.valid && !this.isEditMode,
                'cursor-not-allowed': !this.allowed && this.allowed,
                'cursor-pointer': this.allowed,
                'opacity-50': this.updated,
            }
        }
    },
    watch: {
        forceClose(val) {
            if (val === true && this.isEditMode) {
                if (this.hasChanges) {
                    this.update();
                } else {
                    this.toggleMode();
                }
            }
        },
        originValue(val) {
            this.updated = false;
            this.updatedValue = val;
        },
        updatedValue(newVal, oldVal) {
            if (this.type === 'number') {
                oldVal = parseFloat(oldVal);
                this.updatedValue = parseFloat(newVal);
            }
            if (oldVal !== this.updatedValue) {
                this.$emit('changed', {new: this.updatedValue, old: oldVal});
            }
        }
    }
}
</script>
